import ImageGalleryPager from './ImageGalleryPager';

export default ImageGalleryPager;
